import { createAsyncTypes } from 'utils/ActionCreator'

export const GET_RED_TEAM_STATUS_ASYNC = createAsyncTypes('GET_RED_TEAM_STATUS_ASYNC', 'RedTeam')

export const GET_ATTACK_GENERATION_DATA_ASYNC = createAsyncTypes(
  'GET_ATTACK_GENERATION_DATA_ASYNC',
  'RedTeam'
)

export const GET_COMPANY_RISK_ASYNC = createAsyncTypes('GET_COMPANY_RISK_ASYNC', 'RedTeam')

export const GET_COMPANY_RISK_TREND_ASYNC = createAsyncTypes(
  'GET_COMPANY_RISK_TREND_ASYNC',
  'RedTeam'
)

export const GET_TRAINING_ACTIVITY_ASYNC = createAsyncTypes(
  'GET_TRAINING_ACTIVITY_ASYNC',
  'RedTeam'
)

export const SUBMIT_ATTACK_FEEDBACK_ASYNC = createAsyncTypes(
  'SUBMIT_ATTACK_FEEDBACK_ASYNC',
  'RedTeam'
)

export const SET_TRAINING_ACTIVITY_PAGE = 'RedTeam/SET_TRAINING_ACTIVITY_PAGE'
